import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { ActionConfigDTO, DynamicResponseDTO, FieldConfigDTO, FormRowConfigDTO } from '../../../system/system-dtos';
import { MyErrorStateMatcher } from '../../../common/field-validation/my-error-state-matcher';
import { StringUtils } from '../../../common/string-utils';
import { ActionService } from '../action.service';
import { LookupModalComponent } from '../../data-type-widgets/data-type/shared/lookup/lookup-modal/lookup-modal.component';
import { PlayersDetailsService } from '../../../feature/manage/player/player-details/players-details.service';
@Component({
  selector: 'app-action-modal',
  templateUrl: './action-modal.component.html',
  styleUrls: ['./action-modal.component.scss'],
  standalone: false,
})
export class ActionModalComponent implements OnInit {
  public actionConfig: ActionConfigDTO;

  public loading = false;

  public formGroup: UntypedFormGroup;

  public confirmationFields: FieldConfigDTO[];

  public confirmationFormFields: FieldConfigDTO[];

  public fieldsToDisplay: FieldConfigDTO[];

  public allFields: FieldConfigDTO[];

  public entityData: any;

  public step = 0;

  dynamicResponse: DynamicResponseDTO;

  summaryObject: { value: any; key: string }[];

  public doubleCheckFormGroup: UntypedFormGroup; // we need to pass some form group into app-form-field

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LookupModalComponent>,
    private http: HttpClient,
    private toastrService: ToastrService,
    private route: ActivatedRoute,
    private domSanitizer: DomSanitizer,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.actionConfig = data.config;
    this.entityData = data.entity;
  }

  ngOnInit() {
    if (this.actionConfig.rows && this.actionConfig.rows.length > 0) {
      this.allFields = this.constructAllDisplay();
      this.fieldsToDisplay = this.constructFieldsToDisplay();
      this.confirmationFields = this.fieldsToDisplayInConfirmationStep();
      this.confirmationFormFields = this.fieldsToDisplayInDoubleCheckStep();
      this.doubleCheckFormGroup = this.constructFormGroup(this.confirmationFormFields);
      this.formGroup = this.constructFormGroup(this.allFields);
      this.changeDetectorRef.detectChanges();
    }
  }

  private fieldsToDisplayInDoubleCheckStep() {
    const confirmationFields: FormRowConfigDTO[] = this.actionConfig.confirmationFormRows
      ? this.actionConfig.confirmationFormRows
      : [];
    return this.buildFieldConfig(confirmationFields);
  }

  private constructAllDisplay(): FieldConfigDTO[] {
    return this.buildFieldConfig(this.actionConfig.rows);
  }

  private buildFieldConfig(rowConfig: FormRowConfigDTO[]) {
    return rowConfig
      .map((r) => r.columns)
      .reduce((acc, elem) => acc.concat(elem), [])
      .map((c) => c.fields)
      .reduce((acc, elem) => acc.concat(elem), []);
  }

  private constructFormGroup(fieldsToDisplay: FieldConfigDTO[]) {
    const formGroupBuilder = {};
    fieldsToDisplay.forEach((f) => (formGroupBuilder[f.name] = this.getFormControlForField(f)));
    const formGroup = new UntypedFormGroup(formGroupBuilder);

    fieldsToDisplay
      .filter((f) => !(f.jsRecalculate && f.jsValue && f.jsValue.includes('form.')))
      .forEach((field) => {
        formGroup
          .get(field.name)
          .valueChanges.subscribe(() => this.updateRecalculateFields(fieldsToDisplay, formGroup));
      });

    this.updateRecalculateFields(fieldsToDisplay, formGroup);
    this.changeDetectorRef.detectChanges();
    return formGroup;
  }

  private updateRecalculateFields(fieldsToDisplay: FieldConfigDTO[], formGroup: UntypedFormGroup) {
    const form = formGroup.getRawValue();
    fieldsToDisplay
      .filter((f) => f.jsRecalculate && f.jsValue && f.jsValue.includes('form.'))
      .forEach((f) => {
        formGroup.get(f.name).setValue(eval(f.jsValue), { emitEvent: true });
      });
  }

  private getFormControlForField(f: FieldConfigDTO) {
    const disabled = f.editReadOnly;

    const entity = this.entityData;
    const value = f.jsValue && !f.jsValue.includes('form.') ? eval(f.jsValue) : null;

    const validators = MyErrorStateMatcher.convertToAngularValidators([f]);
    const formControl = new UntypedFormControl(
      {
        value,
        disabled,
      },
      validators
    );
    return formControl;
  }

  no() {
    this.dialogRef.close(false);
  }

  yes() {
    if (this.step === 0 && this.actionConfig.confirmationMessage) {
      this.step += 1;
    } else if (this.step === 0 && this.actionConfig.confirmationUrl) {
      this.loading = true;
      const formValue = this.getFormValue();

      ActionService.actionRequest(
        this.route.params,
        this.entityData && this.entityData.id,
        this.actionConfig,
        formValue,
        StringUtils.convert(this.actionConfig.confirmationUrl, this.data),
        this.http,
        this.toastrService
      ).subscribe(
        (d) => {
          Object.keys(d).forEach((k) => {
            this.doubleCheckFormGroup.setControl(k, new UntypedFormControl(d[k]));
          });
          this.loading = false;
          this.step += 1;
        },
        (e) => (this.loading = false)
      );
    } else if (this.step === 1 && this.actionConfig.displaySummary) {
      this.loading = true;
      const formValue = this.getFormValue();

      ActionService.actionRequest(
        this.route.params,
        this.entityData && this.entityData.id,
        this.actionConfig,
        formValue,
        StringUtils.convert(this.actionConfig.url, this.data),
        this.http,
        this.toastrService
      ).subscribe(
        (d) => {
          this.summaryObject = Object.keys(d).map((key) => ({ key, value: d[key] }));
          this.loading = false;
          this.step += 1;
        },
        (e) => (this.loading = false)
      );
    } else if (this.actionConfig.dynamicResponse && !this.dynamicResponse) {
      const formValue = this.getFormValue();
      this.loading = true;
      this.http
        .request(this.actionConfig.method, StringUtils.convert(this.actionConfig.url, this.entityData), {
          body: Object.keys(formValue).length > 0 ? formValue : 0,
        })
        .subscribe(
          (d: DynamicResponseDTO) => {
            this.dynamicResponse = d;
            this.loading = false;
          },
          (err) => {
            this.loading = false;
          }
        );
    } else {
      this.dialogRef.close(this.getFormValue());
    }
  }

  private getFormValue() {
    return this.formGroup ? this.formGroup.getRawValue() : {};
  }

  private constructFieldsToDisplay() {
    return this.allFields.filter((f) => !f.editHide);
  }

  private fieldsToDisplayInConfirmationStep() {
    const confirmationFields: string[] = this.actionConfig.confirmationFields
      ? this.actionConfig.confirmationFields
      : [];
    return this.allFields.filter((f) => confirmationFields.includes(f.name));
  }

  copyValue() {
    const el: any = document.createElement('textarea');
    el.value = this.dynamicResponse.copyableMessage;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  }

  transform(style: string): SafeStyle {
    if (!style) {
      return 'text-align: right;';
    }
    return this.domSanitizer.bypassSecurityTrustStyle(style);
  }
}
